import React from "react";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import withRouter from "../../../../../../withRouter";
import BaseFormPage from "../../../../../../base/BaseFormPage";
import TrainingCertificatePage from "./TrainingCertificatePage";
import OfficeFormPresenter from "../../../../../OrganizationaStructure/offices/office-form/OfficeFormPresenter";

class TrainingCertificateForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new OfficeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      count: "",
      object: {},
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      console.log("State updated", this.state.object);
    }
  }

  getCollectionName() {
    return "management_training";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { training } = this.state.object;

    if (training !== undefined) {
      console.log("TRAINING DETAILS", training);
    }

    return (
      <>
        <TrainingCertificatePage training={training} />
      </>
    );
  }
}

export default withRouter(TrainingCertificateForm);
